<template>
  <div class="personRule">
    <el-form
      ref="personRule"
      :model="form"
      label-width="180px"
      class="form personRule"
      :rules="personRules"
    >
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>执法检查人员抽取规则</span>
        </div>
        <div v-if="canEditpage">
          <el-row>
            <el-col :span="24">
              <el-form-item label="分组方式：" prop="inspectorsGroupType" style="width:100%;">
                <el-radio-group v-model="form.inspectorsGroupType" @change="changeRadio">
                  <el-radio label="1">线下已分组</el-radio>
                  <el-radio label="2">系统随机分组</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="form.inspectorsGroupType=='2'">
            <el-col :span="24">
              <el-form-item
                label="选择本次执法人员："
                prop="extractPondPersonList"
                style="width:100%;margin-bottom:0"
              >
                <!-- :disabled="disabledFlag" -->
                <el-button icon="el-icon-plus" type="primary" plain @click="showPersonDia()">选择</el-button>
                <div class="selectPersonWrapper" v-if="extractPondPersonList.length > 0">
                  <p style="margin:10px 0 0">
                    共计
                    <span>{{extractPondPersonList.length}}</span>名
                  </p>
                  <!-- 'height':cardMinHeight, -->
                  <el-scrollbar :style="{'min-height':'30px','max-height':'440px'}">
                    <span
                      style="margin: 10px;color:#1890ff"
                      v-for="(item,index) in extractPondPersonList"
                      :key="index"
                    >{{item.name||item.personName + (item.deptName||item.personDesc?("（" + (item.deptName?item.deptName:item.personDesc) + "）"):"")}}</span>
                  </el-scrollbar>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="执法检查人员分组：" prop="groupNum" style="width:100%;">
                执法检查人员共分为
                <el-input-number
                  style="width: 100px;margin-right:20px;"
                  v-model="form.groupNum"
                  controls-position="right"
                  @change="changeGroupNum"
                  :min="0"
                ></el-input-number>个小组
                <el-button
                  type="primary"
                  v-if="form.inspectorsGroupType=='2'"
                  :disabled="form.groupNum>0?false:true"
                  @click="saveAndRandom"
                >开始随机分组</el-button>
                <el-table
                  :data="tableData"
                  height="250"
                  border
                  style="width: 100%"
                  :header-cell-style="this.$globalGrayTableHeaderStyle"
                  ref="tableDataRef"
                >
                  <el-table-column label="分组" width="150" align="center">
                    <template slot-scope="scope">
                      <span>分组{{scope.$index+1}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="name" label="执法检查人员名称" align="center">
<!--                   TODO 执法检查人员名称翻译优化，不再多次循环, 用formatt翻译出来 -->
                  </el-table-column>
                  <el-table-column label="操作" width="150" align="center">
                    <template slot-scope="scope">
                      <el-button
                        v-if="form.inspectorsGroupType!='2'"
                        @click="showPersonDia(scope.$index)"
                        type="text"
                        size="small"
                      >选择执法人员</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div v-if="!canEditpage">
          <el-row>
            <el-col :span="24">
              <el-form-item label="分组方式：" prop="extractPondPersonList" style="width:100%;">
                <span>{{form.inspectorsGroupType?(form.inspectorsGroupType=='1'?"线下已分组":"系统随机分组"):"---"}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="本次执法人员：" prop="extractPondPersonList" style="width:100%;">
                <span>{{form.extractPondPersonName||"---"}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="执法检查人员分组：" prop="groupNum" style="width:100%;">
                共分为
                <span>{{form.groupNum}}</span>个小组
                <el-table
                  :data="tableData"
                  height="250"
                  border
                  style="width: 100%"
                  :header-cell-style="this.$globalGrayTableHeaderStyle"
                >
                  <el-table-column label="分组" width="150" align="center">
                    <template slot-scope="scope">
                      <span>分组{{scope.$index+1}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="name" label="执法检查人员名称" align="center"></el-table-column>
                  <!-- <el-table-column label="操作" align="center">
                    <template slot-scope="scope" width="150">
                      <el-button
                        @click="showPersonDia(scope.$index)"
                        type="text"
                        size="small"
                        disabled
                      >选择执法人员</el-button>
                    </template>
                  </el-table-column>-->
                </el-table>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-card>
      <personSelectDia
        ref="personSelectDiaRef"
        :dialogVisible.sync="extractPersonPondListDialog"
        @dialogVisibles="cancelDialog"
        @setSelectList="setSelectList"
        :isdisabled="true"
      ></personSelectDia>
    </el-form>
  </div>
</template>

<script>
import personSelectDia from "./personSelectDia";
export default {
  props: {
    isdisable: {
      type: Boolean,
      default: () => false
    },
    formData: {
      type: Object,
      default: () => {}
    }
  },
  components: { personSelectDia },

  data() {
    return {
      indexNumber: "", // 当前点击行号
      canEditpage: true,
      tableData: [],
      form: {
        inspectorsGroupType: "1",
        groupNum: "",
        taskId: "",
        groupAvg: 0,
        extractExectors: []
      },
      personRules: {
        inspectorsGroupType: [
          { required: true, message: "请选择分组方式", trigger: "blur" }
        ],
        groupNum: [
          {
            required: true,
            message: "请对执法检查人员进行分组",
            trigger: "blur"
          }
        ]
      },
      formString: "",
      extractPersonPondListDialog: false,
      extractPondPersonList: [],
      extractPondPersonListString: "",
      disabledList: [], // 禁止选择的人
      lengths: [],
      currentList: []
    };
  },
  computed: {
    executorList: {
      get() {
        return this.form.executorList;
      },
      set(val) {}
    }
  },
  watch: {
    formData: {
      deep: true,
      immediate: true,
      handler(newV, oldV) {
        this.form = JSON.parse(JSON.stringify(newV));
        this.form.taskId = newV.id;
        this.canEditpage=this.form.canEdit
        // 回显表格行数
        this.changeGroupNum(this.form.groupNum);
        // // 回显检查人员
        // this.reviewTable(this.form.executorList);
      }
    },

    // groupList: {
    //   deep: true,
    //   immediate: true,
    //   handler(newV, oldV) {
    //     if(newV){
    //       // this.groupListCopy = JSON.parse(JSON.stringify(newV));
    //     }
    //   }
    // },
    //  选择的执法人员集合 （去重）
    executorList: {
      deep: true,
      immediate: true,
      handler(newV, oldV) {
        if (newV) {
          this.reviewTable(newV);
        }
      }
    }

    // form: {
    //   deep: true,
    //   immediate: true,
    //   handler(newV, oldV) {
    //     this.$emit("changePersionFormMethods", newV);
    //   }
    // },
  },
  mounted() {
    // this.form.taskId = this.$route.query.id || "";
    this.getExtractExectorList();
  },
  methods: {
    validate(callback) {
      //这个form是子组件内部 el-form 的 ref="baseInfoForm"
      this.$refs.personRule.validate(valid => {
        callback(valid);
      });
    },
    // 打开弹窗选择人员
    showPersonDia(index) {
      this.indexNumber = isNaN(index) ? "" : index;
      this.extractPersonPondListDialog = true;
      let tempList =
        this.form.inspectorsGroupType == "1"
          ? this.tableData[index]
            ? this.tableData[index].cur
            : []
          : this.extractPondPersonList;
      // this.$refs.personSelectDiaRef.initData(this.extractPondPersonList);
      this.$refs.personSelectDiaRef.initData(tempList);
      if (this.form.inspectorsGroupType == "2") {
        this.executorList = [];
        this.form.extractExectors = [];
        this.extractPondPersonList = [];
      }
    },
    cancelDialog() {
      this.extractPersonPondListDialog = false;
      this.extractPondPersonList = [];
    },
    setSelectList(val) {
      // console.log(val, "val");
      // 弹窗 直接全选没有userid 需要修改

      let valList = [...val];
      // 线下分组
      if (this.form.inspectorsGroupType == "1" && val.length > 0) {
        valList.forEach((element, index) => {
          delete element.attributes;
          delete element.id;
          element.taskId = this.form.taskId;
          element.groupNo = this.indexNumber + 1;
        });
      } else {
        valList.forEach((element, index) => {
          delete element.attributes;
          delete element.id;
          element.taskId = this.form.taskId;
        });
      }
      // this.form.extractExectors.push(...valList);
      let fildata = this.form.extractExectors.filter(item => {
        return item.groupNo != valList[0].groupNo;
      });
      let newList = valList.concat(fildata);
      this.form.extractExectors = JSON.parse(JSON.stringify(newList));
      this.$set(this.form, "executorList", this.form.extractExectors);
      // 解决选择执法人员导致表单清空
      if (this.form.inspectorsGroupType == "1") {
        this.$emit('uploadParentForm')
        // this.$emit("update:formData", this.form);
      }
      // 在页面表格中展示 线下
      if (this.form.inspectorsGroupType == "1") {
        let valString = "";
        valList.forEach((element, index) => {
          valString +=
            element.name +
            (element.deptName ? "(" + element.deptName + ")" : "") +
            (index === valList.length - 1 ? "" : ",");
        });
        this.tableData[this.indexNumber].name = valString;
        this.tableData[this.indexNumber].cur = val;
        this.$emit("setGroupData", this.tableData);
      }

      this.extractPondPersonList = val;
    },
    reviewTable(dataList) {
      if (!dataList) {
        return;
      }
      this.tableData.forEach((item, index) => {
        item.name = "";
        item.cur = [];
      });
      dataList.forEach((element, index) => {
        if (element.groupNo == 0 || element.groupNo == undefined) {
          return;
        }
        element.name = element.personName;
        element.deptName = element.personDesc ? element.personDesc : "";

        this.tableData[element.groupNo - 1].name +=
          (this.tableData[element.groupNo - 1].name ? "," : "") +
          element.personName +
          (element.personDesc ? "(" + element.personDesc + ")" : "");
        this.tableData[element.groupNo - 1].cur.push(element);
      });
      // this.form.extractExectors=dataList
      // 回写本次执法人员
      this.extractPondPersonList = dataList;
      //设置到组 回显匹配结果表格select
      this.$emit("setGroupData", this.tableData);
    },
    changeRadio() {
      this.extractPondPersonList = [];
      this.tableData.forEach((item, index) => {
        item.name = "";
        item.cur = [];
      });
    },
    changeGroupNum(number) {
      let num = 0;
      if (this.count == 0) {
        num = number;
        this.count += 1;
      } else {
        num = number - this.tableData.length;
      }
      if (num > 0) {
        for (let j = 0; j < num; j++) {
          this.tableData.push({
            name: "",
            cur: [],
            indexNumber: j
          });
        }
      } else {
        this.tableData = this.tableData.slice(0, this.tableData.length + num);
      }
      // 设置每组人数
      if (this.extractPondPersonList.length > 0) {
        this.form.groupAvg = Math.ceil(
          this.extractPondPersonList.length / number
        );
      } else {
        this.form.groupAvg = 0;
      }
    },
    // 保存时不校验 不管是否填写先保存一次 拿到id 再进行校验=》随机分组
    saveAndRandom() {
      this.$emit("saveAndRandom", this.beginRandomGroup);
    },
    // 点击开始随机分组
    beginRandomGroup(id) {
      if (this.extractPondPersonList.length < 1) {
        this.$message.error("请选择本次执法人员！");
        return;
      }
      if (this.extractPondPersonList.length < this.form.groupNum) {
        this.$message.error("执法检查人员数量 需>= 执法检查组数，否则无法分组！");
        return;
      }
       if(this.extractPondPersonList.length%this.form.groupNum!==0){
        this.$confirm('本次执法人员总数与执法检查人员分组不能平均分配, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 网络请求
          this.getdataMethods(id)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });          
        });
       }else{
        this.getdataMethods(id)
       }
    },
    getdataMethods(valId){
      let taskId=this.form.taskId||valId
      this.$httpReq
        .get(
          "/projectDoubleExtract/extractexector/startExtractPersonnel?taskId=" +
          taskId
        )
        .then(res => {
          if (res.data.code == "1" && res.data.data) {
            let dataList = res.data.data;
            this.form.extractExectors = dataList;
            this.setTableData(dataList);
            this.$message.success("随机抽取成功");
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    setTableData(dataList) {

      dataList.forEach((element, index) => {
        this.tableData[element.groupNo - 1].name =(this.tableData[element.groupNo - 1].name?this.tableData[element.groupNo - 1].name+',':'')+
          element.personName +
          (element.personDesc ? "(" + element.personDesc + ")" : "")
      });
      // this.tableData.forEach((item, index) => {
      //   item.name = item.name.substr(0, item.name.length - 1);
      // });
      // 刷新页面 才能将执法人员写入
      this.$emit("reloadPage")
      this.$emit("setGroupData", this.tableData);
    },
    getExtractExectorList() {
      // 获取选择执法人员和分组数
      this.$httpReq
        .get(
          "/projectDoubleExtract/extractexectorfilter/getPersonAndRule?extractTaskId=" +
            this.form.taskId
        )
        .then(res => {
          if (res.data.code == "1" && res.data.data) {
            this.extractPondPersonList = res.data.data.executorList || [];
            this.extractPondPersonList.forEach(item => {
              item.id = item.personUserId || "";
              item.name = item.personName || "";
              item.deptName = item.personDesc || "";
            });
            this.form = { ...res.data.data.executorFilter };
            this.formString = JSON.stringify(this.form);
            this.extractPondPersonListString = JSON.stringify(
              this.extractPondPersonList
            );
          } else {
            this.extractPondPersonList = [];
            this.form.groupNum = 0;
          }
        });
    }
  }
};
</script>
  <style lang="scss" scoped>
.personRule {
  /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #3e8ef7;
  }
  /deep/ .dialog-right-content ul li p {
    color: black;
  }
}
</style>